module.exports = __webpack_public_path__ + "04_glasses_red.8e4536b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer4/04_glasses_red.png
// module id = BCTj
// module chunks = 0